// packages/world-model/src/traits/backdrop/index.ts

export { BackdropTrait } from './backdropTrait.js';
export type { IBackdropData } from './backdropTrait.js';
